import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

export const useFiltersFromUrl = () => {
  const history = useHistory();
  const [filters, setFilters] = useState<Record<string, string[]>>({});

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const newFilters: Record<string, string[]> = {};

    params.forEach((value, key) => {
      if (key !== "game" && key !== "view" && key !== "user") {
        if (!newFilters[key]) newFilters[key] = [];
        newFilters[key].push(value);
      }
    });

    setFilters(newFilters);
  }, []);

  const updateUrl = (newFilters: Record<string, string[]>) => {
    const params = new URLSearchParams(window.location.search);

    const game = params.get("game");
    const view = params.get("view");

    [...params.keys()].forEach((key) => params.delete(key));

    if (game) params.set("game", game);
    if (view) params.set("view", view);

    Object.entries(newFilters).forEach(([key, values]) => {
      if (values.length) params.set(key, values.join(","));
    });

    history.replace({ search: params.toString() });
  };

  return { filters, setFilters, updateUrl };
};
